export default "/images/vendor/flag-icon-css/flags/1x1/tr.svg?1a109fa73fffdfd33b11a168f71fa60f";